import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';

export const MainLayout = () => {
  return (
    <div className="flex h-screen overflow-hidden bg-[#0a0a0a]">
      <div className="hidden lg:block w-64 xl:w-80 flex-shrink-0">
        <div className="h-full overflow-y-auto scrollbar-hide">
          <Sidebar />
        </div>
      </div>
      
      <MobileNav />
      
      <main className="flex-1 overflow-y-auto relative">
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;